import React from 'react';
import { Fish, AlertTriangle, Bell, CheckCircle } from 'lucide-react';
import { Card } from '@/shared/components/ui/Card';
import type { MorningSummaryQuickStats } from '../types';

interface QuickStatsGridProps {
  stats: MorningSummaryQuickStats;
}

export const QuickStatsGrid: React.FC<QuickStatsGridProps> = ({ stats }) => {
  const statItems = [
    {
      label: 'Active Ponds',
      value: stats.activePondCount,
      icon: Fish,
      color: 'text-blue-600 bg-blue-50',
      subtitle: `of ${stats.totalPondCount} total`,
    },
    {
      label: 'Needing Attention',
      value: stats.attentionPondCount,
      icon: AlertTriangle,
      color: stats.attentionPondCount > 0 ? 'text-amber-600 bg-amber-50' : 'text-emerald-600 bg-emerald-50',
      subtitle: stats.attentionPondCount > 0 ? 'ponds require action' : 'all ponds healthy',
    },
    {
      label: 'Alerts (24h)',
      value: stats.alertCount24h,
      icon: Bell,
      color: stats.alertCount24h > 0 ? 'text-red-600 bg-red-50' : 'text-emerald-600 bg-emerald-50',
      subtitle: stats.alertCount24h > 0 ? 'issues detected' : 'no issues',
    },
    {
      label: 'Checked Today',
      value: stats.pondsCheckedToday,
      icon: CheckCircle,
      color: 'text-emerald-600 bg-emerald-50',
      subtitle: `of ${stats.totalPondCount} ponds`,
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {statItems.map((item) => {
        const Icon = item.icon;
        return (
          <Card key={item.label} className="p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">{item.label}</p>
                <p className="mt-1 text-2xl font-bold text-gray-900">{item.value}</p>
                <p className="mt-0.5 text-xs text-gray-400">{item.subtitle}</p>
              </div>
              <div className={`p-2 rounded-lg ${item.color}`}>
                <Icon className="h-5 w-5" />
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
